export default{
  "Mute Video": "Vidéo muette",
  "HitPaw Online Mute Video": "HitPaw vidéo muette en ligne",
  "Fast and easy to remove sound from your video online": "Suppression rapide et facile du son de votre vidéo",
  "Muting": "Muet en cours",
  "Mute Failed": "Échec du mute",
  "Mute New": "Muet Nouveau"
};